import { postMessageToNative } from "~/lib/webview";
import { getAdjustToken } from "./adjustTokens";
import { getCurrentAdjustPlatform, isNativeApplication } from "./platform";

/**
 * Adjust イベントを送信する（ネイティブアプリのみ）。
 *
 * - isNativeApplication() が false の場合は何もしない
 * - ADJUST_TOKENS にトークンが定義されていないイベント・プラットフォームは送信しない
 */
export const trackAdjustEvent = (eventName: string): void => {
  setTimeout(() => {
    try {
      if (!isNativeApplication()) return;

      const platform = getCurrentAdjustPlatform();
      if (!platform) return;

      const eventToken = getAdjustToken(eventName, platform);
      if (!eventToken) return;

      postMessageToNative({
        type: "ADJUST_TRACK_EVENT",
        payload: {
          eventToken,
          callbackParams: [],
          partnerParams: [],
        },
      });
    } catch {
      // 補助機能のため例外は握りつぶす
    }
  }, 0);
};
